import { doRequest } from '@r1-frontend/do-request';
import subscriptions, { ResponseDto, ResponseSubscriptionType } from '@r1-frontend/api-domru/api-tariffs/v1/tariffs/[salePackageId]/subscriptions';

import { setSubscriptions } from '~/src/features/full-buy/store/actions';
import { setBundleOfSubscriptions } from '~/src/features/full-buy/store/actions/setBundleOfSubscriptions';
import { toggleBackgroundLoading } from '~/src/features/full-buy/store/actions/toggleBackgroundLoading';
import { getListDescription } from '~/src/features/full-buy/store/helpers/getListDescription';
import { TSubscription } from '~/src/features/full-buy/store/initialState';
import { IFullBuyTariff } from '~/src/features/full-buy/store/tariffTransformer';
import { TAppThunkDispatch } from '~/src/store';

const needToLoadSubscriptions = (tariff: IFullBuyTariff) => {
    return 'salePackageLinks' in tariff && Array.isArray(tariff.salePackageLinks) && tariff.salePackageLinks.length > 0;
};

const getSubscriptions = (tariff: IFullBuyTariff) => async(dispatch: TAppThunkDispatch) => {
    if (!tariff || !needToLoadSubscriptions(tariff)) {
        return;
    }

    dispatch(toggleBackgroundLoading(true));

    const response = await doRequest.apiTariffs<ResponseDto[]>(subscriptions(tariff.sale_package_id));

    if (response.isSuccess) {
        const dataWithFullDescriptionList = response.payload.map(item => {
            return {
                ...item,
                fullDescriptionList: getListDescription(item.fullDescription),
            };
        });
        dispatch(setSubscriptions(tariff.sale_package_id, dataWithFullDescriptionList));
    }

    dispatch(toggleBackgroundLoading(false));
};

const receiveSubscriptions = async(tariff: IFullBuyTariff) => {
    if (tariff && needToLoadSubscriptions(tariff)) {
        const response = await doRequest.apiTariffs<ResponseDto[]>(subscriptions(tariff.sale_package_id));

        if (response.isSuccess) {
            return {
                tariffId: tariff.sale_package_id,
                subscriptions: response.payload.map(item => {
                    return {
                        ...item,
                        fullDescriptionList: getListDescription(item.fullDescription),
                    };
                }),
            };
        }
    }
};

export const getBundleOfSubscriptions = (tariffs: IFullBuyTariff[]) => async(dispatch: TAppThunkDispatch) => {
    dispatch(toggleBackgroundLoading(true));

    const response = await Promise.all(tariffs.map(receiveSubscriptions));

    const result = response
        // eslint-disable-next-line
        .reduce<Record<number, { oneOf: number[], items: TSubscription[] }>>(
            (acc, item) => {
                if (!item) {
                    return acc;
                }

                acc[item.tariffId] = {
                    oneOf: item.subscriptions
                        .filter(s => s.type === ResponseSubscriptionType.oneOf)
                        .map(s => s.serviceId),
                    items: item.subscriptions,
                };
                return acc;
            }, {},
        );

    dispatch(setBundleOfSubscriptions(result));
    dispatch(toggleBackgroundLoading(false));
};

export default getSubscriptions;
